import React, { useEffect } from 'react'
import Layout from './Layout'
import ExerciseTile from './ExerciseTile'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_EXERCISES } from '../redux/exercisesReducer'
import { RootReducer } from '../redux/rootReducer'
import AddExerciseButton from './AddExerciseButton'

type Props = {}

const ExercisesScreen = (props: Props) => {
  const { lessonPlanId, unitId } = useParams()
  const dispatch = useDispatch()

  useEffect(() => {
    if (lessonPlanId && unitId) {
      dispatch(FETCH_EXERCISES({ lessonPlanId: Number(lessonPlanId), unitId: Number(unitId) }))
    }
  }, [lessonPlanId, unitId, dispatch])

  const exercises = useSelector((state: RootReducer) => {
    if (lessonPlanId) {
      return state.exercisesReducer.exercises[Number(lessonPlanId)] || []
    }
    return []
  })

  return (
    <Layout>
      <div>
        <div className="text-18 font-semibold">Exercises</div>
        <div className="flex justify-end gap-2">
          <AddExerciseButton />
        </div>
        <div className="h-4" />
        <div className="grid grid-cols-3 gap-4">
          {exercises.map((exercise) => (
            <ExerciseTile key={exercise.id} exercise={exercise} />
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default ExercisesScreen
